import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCollections = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Laag_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 19.1 17.2",
	style: { enableBackground: "new 0 0 19.1 17.2" },
	xmlSpace: "preserve",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("filter", {
			id: "Adobe_OpacityMaskFilter",
			filterUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 19.1,
			height: 17.2,
			children: /* @__PURE__ */ _jsx("feColorMatrix", {
				type: "matrix",
				values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
			})
		}) }),
		/* @__PURE__ */ _jsx("mask", {
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 19.1,
			height: 17.2,
			id: "mask0_308_29121_00000090992571171044194860000013956401083035697795_",
			children: /* @__PURE__ */ _jsx("rect", {
				x: -3.9,
				y: -4.9,
				className: "st0",
				width: 27,
				height: 27
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			className: "st1",
			children: /* @__PURE__ */ _jsx("path", {
				className: "st2",
				d: "M6.5,16.2v-1.7h12.6v1.7H6.5z M6.5,9.5V7.8h12.6v1.7H6.5z M6.5,2.7V1h12.6v1.7H6.5z M1.9,17.2 c-0.5,0-1-0.2-1.3-0.5C0.2,16.3,0,15.9,0,15.4s0.2-1,0.5-1.3c0.4-0.4,0.8-0.5,1.3-0.5s1,0.2,1.3,0.5c0.4,0.4,0.5,0.8,0.5,1.3 s-0.2,1-0.5,1.3C2.8,17.1,2.4,17.2,1.9,17.2z M1.9,10.5c-0.5,0-1-0.2-1.3-0.5C0.2,9.6,0,9.1,0,8.6s0.2-1,0.5-1.3 c0.4-0.4,0.8-0.5,1.3-0.5s1,0.2,1.3,0.5c0.4,0.4,0.5,0.8,0.5,1.3s-0.2,1-0.5,1.3C2.8,10.3,2.4,10.5,1.9,10.5z M1.9,3.7 c-0.5,0-1-0.2-1.3-0.5C0.2,2.8,0,2.4,0,1.9c0-0.5,0.2-1,0.5-1.3C0.9,0.2,1.4,0,1.9,0s1,0.2,1.3,0.5c0.4,0.4,0.5,0.8,0.5,1.3 c0,0.5-0.2,1-0.5,1.3C2.8,3.6,2.4,3.7,1.9,3.7z",
				fill: "currentColor"
			})
		})
	]
});
export { SvgCollections as ReactComponent };
